import React, { useState, useRef } from "react";
import { getProfile } from "../../../services/authservice";
import QuillEditor from "../postEditor/quillEditor";
import { savePost } from "./../../../services/posts";
// import MultipleFileDropzone from "../../../components/PageForum/form/fileUploader";
// import { saveAttachmentsInternalTopic } from "../../../services/attachments";
import MyEditor from "../../../components/common/Editor";

const ReplyTopic = (props) => {
  const [editPost, setEditPost] = useState({ narrative: "", reply: "" });
  const [uploadeProgress, setUploadProgress] = useState(0);
  const [attachments, setAttachments] = useState([]);
  const [files, setFiles] = useState([]);
  const editThread = (content) => {
    let postEdit = content;
    setEditPost({ narrative: postEdit });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const currentUser = await getProfile();

    let editPostData = {};
    if (props.reply === "topic") {
      editPostData = {
        topicId: props.Post._id,
        narrative: editPost.narrative,
        user: currentUser._id,
        status: "active",
      };

      try {
        const resp = await savePost(editPostData);
        if (attachments?.length > 0) {
          // Use a state to track the progress
          // Call saveAttachmentsInternalTopic with the onUploadProgress callback
          console.log(attachments);
          // const data = await saveAttachmentsInternalTopic(
          //   attachments,
          //   "post",
          //   resp?.data?._id,
          //   (progressEvent) => {
          //     const progress = Math.round(
          //       (progressEvent.loaded / progressEvent.total) * 100
          //     );
          //     setUploadProgress(progress);
          //     console.log("this is progress");
          //     console.log(progress);
          //   }
          // );
          // console.log(data);
        }
      } catch (error) {}
    } else {
      editPostData = {
        topicId: props.Post.topicId._id,
        parentId: props.Post._id,
        narrative: editPost.narrative,
        user: currentUser._id,
        status: "active",
      };

      try {
        const resp = await savePost(editPostData);
        if (attachments?.length > 0) {
          // Use a state to track the progress
          // Call saveAttachmentsInternalTopic with the onUploadProgress callback
          console.log(attachments);
          // const data = await saveAttachmentsInternalTopic(
          //   attachments,
          //   "post",
          //   resp?.data?._id,
          //   (progressEvent) => {
          //     const progress = Math.round(
          //       (progressEvent.loaded / progressEvent.total) * 100
          //     );
          //     setUploadProgress(progress);
          //     console.log("this is progress");
          //     console.log(progress);
          //   }
          // );
          // console.log(data);
        }
      } catch (error) {}
    }

    props.submitReplyForm(e);
    props.loadPage();
  };

  const handleCancel = (e) => {
    props.submitReplyForm(e);
    e.preventDefault();
  };

  return (
    <div>
      <div class="col-lg-12 ml-2">
        <div class="row justify-content-center">
          <form>
            <MyEditor
              initialContent={editPost.narrative}
              onChangeHandler={(text) => editThread(text)}
            />

            <div className="mt-1">
              <button
                class="btn btn-outline-secondary btn-sm mr-1"
                type="submit"
                onClick={handleSubmit}
              >
                Submit
              </button>
              <button
                class="btn btn-outline-secondary btn-sm"
                type="submit"
                onClick={handleCancel}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ReplyTopic;
